import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const PRIMARY_MENU_ITEMS = [
  "Advisor Portal",
  "Financial Planning",
  "Portfolio Management",
  "Marketing & Sales",
  "Education & Licensing",
  "Administrative",
];

const Breadcrumbs = ({ items }) => {
  const navigate = useNavigate();

  const handleHomeClick = (e) => {
    e.preventDefault();
    navigate("/home-dashboard");
  };

  const getUpdatedPath = (item) => {
    if (item.label === "Client Database")
      return "/advisor-portal/client-database";
    if (item.label === "Household Profile") {
      // Extract householdId from the path
      const match = item.path.match(/\/household-profile\/(\d+)/);
      if (match) {
        const householdId = match[1];
        return `/advisor-portal/client-database/household-profile/${householdId}`;
      }
    }
    return item.path;
  };

  if (!items || !Array.isArray(items)) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
    >
      <div className="flex items-center text-sm text-gray-500 dark:text-gray-500">
        <a
          href="#"
          onClick={handleHomeClick}
          className="hover:text-gray-700 dark:text-gray-300 transition-colors duration-200"
        >
          Home
        </a>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <svg
              className="h-5 w-5 mx-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
            {index === items.length - 1 ? (
              <motion.span
                className="text-gray-900 dark:text-gray-100"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2, delay: 0.1, ease: "easeInOut" }}
              >
                {item.label}
              </motion.span>
            ) : PRIMARY_MENU_ITEMS.includes(item.label) ? (
              <span className="text-gray-500 dark:text-gray-500 cursor-default">{item.label}</span>
            ) : (
              <Link
                to={getUpdatedPath(item)}
                className="hover:text-gray-700 dark:text-gray-300 transition-colors duration-200"
                onClick={() => {
                  // console.log(
                  //   `Clicked ${item.label} from ${window.location.pathname}, Target: ${getUpdatedPath(item)}`,
                  // );
                }}
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        ))}
      </div>
    </motion.div>
  );
};

export default Breadcrumbs;
